"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setLoadCoreImplementation = exports.reset = exports.withLibcoreF = exports.withLibcore = exports.afterLibcoreGC = exports.libcoreJobBusy = void 0;
var logs_1 = require("@ledgerhq/logs");
var invariant_1 = __importDefault(require("invariant"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var GC_DELAY = 1000;
var core;
var corePromise;
var libcoreJobsCounter = 0;
var lastFlush = Promise.resolve();
var flushTimeout = null;
var libcoreJobsCounterSubject = new rxjs_1.Subject();
exports.libcoreJobBusy = libcoreJobsCounterSubject.pipe((0, operators_1.map)(function (v) { return v > 0; }), (0, operators_1.distinctUntilChanged)());
var afterLibcoreFlushes = [];
function flush(c) {
    var _this = this;
    (0, logs_1.log)("libcore/access", "flush");
    lastFlush = c
        .flush()
        .then(function () { return __awaiter(_this, void 0, void 0, function () {
        var item, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(item = afterLibcoreFlushes.shift())) return [3 /*break*/, 2];
                    _b = (_a = item).resolve;
                    return [4 /*yield*/, item.job(c)];
                case 1:
                    _b.apply(_a, [_c.sent()]);
                    return [3 /*break*/, 0];
                case 2:
                    (0, logs_1.log)("libcore/access", "flush end");
                    return [2 /*return*/];
            }
        });
    }); })["catch"](function (e) {
        (0, logs_1.log)("libcore/access", "flush error " + String(e));
        console.error(e);
    });
}
function afterLibcoreGC(job) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    if (!core)
                        return;
                    (0, logs_1.log)("libcore/access", "new after gc job");
                    afterLibcoreFlushes.push({
                        job: job,
                        resolve: resolve
                    });
                    if (libcoreJobsCounter === 0) {
                        (0, logs_1.log)("libcore/access", "after gc job exec now");
                        if (flushTimeout) {
                            clearTimeout(flushTimeout);
                        }
                        flushTimeout = setTimeout(flush.bind(null, core), GC_DELAY);
                    }
                })];
        });
    });
}
exports.afterLibcoreGC = afterLibcoreGC;
function withLibcore(job) {
    return __awaiter(this, void 0, void 0, function () {
        var c, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    libcoreJobsCounter++;
                    libcoreJobsCounterSubject.next(libcoreJobsCounter);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 5, 6]);
                    if (flushTimeout) {
                        // there is a new job so we must not do the GC yet.
                        clearTimeout(flushTimeout);
                        flushTimeout = null;
                    }
                    return [4 /*yield*/, load()];
                case 2:
                    c = _a.sent();
                    return [4 /*yield*/, lastFlush];
                case 3:
                    _a.sent(); // wait previous flush before starting anything
                    return [4 /*yield*/, job(c)];
                case 4:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 5:
                    libcoreJobsCounter--;
                    libcoreJobsCounterSubject.next(libcoreJobsCounter);
                    if (c && libcoreJobsCounter === 0) {
                        flushTimeout = setTimeout(flush.bind(null, c), GC_DELAY);
                    }
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.withLibcore = withLibcore;
var withLibcoreF = function (job) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return withLibcore(function (c) { return job(c).apply(void 0, __spreadArray([], __read(args), false)); });
    };
};
exports.withLibcoreF = withLibcoreF;
var loadCoreImpl;
// reset the libcore data
function reset() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, logs_1.log)("libcore/access", "reset");
                    if (!core)
                        return [2 /*return*/];
                    (0, invariant_1["default"])(libcoreJobsCounter === 0, "some libcore jobs are still running");
                    return [4 /*yield*/, core.getPoolInstance().freshResetAll()];
                case 1:
                    _a.sent();
                    core = null;
                    corePromise = null;
                    return [2 /*return*/];
            }
        });
    });
}
exports.reset = reset;
function load() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (core) {
                        return [2 /*return*/, core];
                    }
                    if (!corePromise) {
                        if (!loadCoreImpl) {
                            console.warn("loadCore implementation is missing");
                            throw new Error("loadCoreImpl missing");
                        }
                        (0, logs_1.log)("libcore/access", "load core impl");
                        corePromise = loadCoreImpl();
                    }
                    return [4 /*yield*/, corePromise];
                case 1:
                    core = _a.sent();
                    return [2 /*return*/, core];
            }
        });
    });
}
function setLoadCoreImplementation(loadCore) {
    loadCoreImpl = loadCore;
}
exports.setLoadCoreImplementation = setLoadCoreImplementation;
//# sourceMappingURL=access.js.map